module.exports = __webpack_public_path__ + "img/MengqiLei.b5c922e3.jpg";